const prefix = 'purchases';

export const GET_ALL = `${prefix}/GET_ALL`; 
export const FETCH_FILTERED = `${prefix}/FETCH_FILTERED`;
export const FIND = `${prefix}/FIND`;
export const GET_HISTORY = `${prefix}/GET_HISTORY`;
export const CREATE_RENEWAL = `${prefix}/CREATE_RENEWAL`;
export const CREATE = `${prefix}/CREATE`;
export const ADD_LINE_ITEM = `${prefix}/ADD_LINE_ITEM`;
export const RECALCULATE_SHIPPING = `${prefix}/RECALCULATE_SHIPPING`;
export const SET_SHIPPING_OPTIONS = `${prefix}/SET_SHIPPING_OPTIONS`;
export const DESTROY = `${prefix}/DESTROY`;
export const CREATE_SPRINT_UPGRADE = `${prefix}/CREATE_SPRINT_UPGRADE`;
export const CREATE_BYPASSED_UPGRADE = `${prefix}/CREATE_BYPASSED_UPGRADE`;
export const CREATE_QUICK_UPGRADE = `${prefix}/CREATE_QUICK_UPGRADE`;
export const MERGE_PURCHASES = `${prefix}/MERGE_PURCHASES`;

export const LOAD_LINE_ITEMS = `${prefix}/LOAD_LINE_ITEMS`;
